import React from 'react';
import { Pane, Strong, TextInputField, TextareaField } from 'evergreen-ui';
import JsonParameters from 'Shared/JsonParameters';
import { DataValueTSFull } from './types';

type EditFormProps = {
  measurement: DataValueTSFull
  onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void
  isSeries: boolean
  existingPoints?: number []
}

export default function EditForm({ measurement, onChange, isSeries, existingPoints = [] }: EditFormProps) {
  const tsJsonParams = measurement.jsonParameters?.jsonParameters || null;

  const isInvalidPoint = measurement.point === null
  || Number.isNaN(+measurement.point)
  || (measurement.isNew && existingPoints.includes(+measurement.point));

  return (
    <Pane display="grid" gridTemplateRows="1fr max-content" rowGap=".5rem">
      <Pane display="grid" gridAutoFlow="row" gridAutoRows="max-content" rowGap=".5rem">
        <TextInputField
          margin={0}
          label="Местоположение"
          name="place"
          value={measurement.place || ''}
          disabled
        />
        {
          isSeries && (
            <TextInputField
              margin={0}
              label="Номер замера"
              name="point"
              disabled={!measurement.isNew
                || (!measurement.isNew && measurement.point && existingPoints.includes(+measurement.point as number))}
              onChange={onChange}
              value={measurement.point ?? ''}
              isInvalid={isInvalidPoint}
            />
          )
        }
        <TextInputField
          margin={0}
          label="Значение"
          name="value"
          onChange={onChange}
          value={measurement.value ?? ''}
          isInvalid={!measurement.value || Number.isNaN(+measurement.value)}
        />
        <TextareaField
          margin={0}
          name="dataValueComment"
          label="Комментарий"
          placeholder="Добавить комментарий..."
          value={measurement.dataValueComment?.comment || ''}
          onChange={onChange}
          style={{ resize: 'none' }}
        />
        {tsJsonParams ? <JsonParameters parameters={tsJsonParams} /> : <Strong>Параметры отсутствуют</Strong>}
      </Pane>
    </Pane>
  );
}
